import TabItem from '@navi/web-ui/lib/components/Tabs/TabItem';
import Tabs from '@navi/web-ui/lib/components/Tabs/Tabs';
import React, { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { COMMUNICATION_TAB_KEYS, COMMUNICATION_TABS } from '../../constants';
import styles from './index.module.scss';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import cx from 'classnames';
import { fetchLegalDocs } from '../../actions/EmiScheduleActions';
import { useDispatch, useSelector } from 'react-redux';
import { createKey } from '@cp/src/utils/CaseDetail.utils';
import { RootState } from '@cp/src/store';
import { DPD_BUCKET_30 } from './constants';
import { GenericObject } from '@cp/src/types/CommonConstans';
import { createQueryParams, readQueryParams } from '@cp/utils/QueryParamsHelper';
import { PAUSE_CASE_LH_VISIBILITY_ROLES } from '@cp/src/constants/Common.constants';

function CommunicationHistory() {
  const { loanId = '', customerId = '' } = useParams();
  const dispatch = useDispatch();
  const pageData = useSelector(
    (state: RootState) => state.caseDetail.pageData?.[createKey(loanId, customerId)]
  );
  const { data: caseDetails } = pageData?.details || {};
  const currentDpd = caseDetails?.currentDpd || 0;

  useEffect(() => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_Interactions_PageLand, { loanId, customerId });
  }, []);

  useEffect(() => {
    if (currentDpd > DPD_BUCKET_30) {
      dispatch(fetchLegalDocs(loanId, customerId));
    }
  }, [currentDpd]);
  const navigate = useNavigate();

  const updateAndNavigate = (params: GenericObject) => {
    const url = createQueryParams(params);
    navigate(url, { replace: true });
  };

  const INTERACTION_TAB = 'interaction';
  const { [INTERACTION_TAB]: queryParams } = readQueryParams();

  const handleTabChange = useCallback((selectedSubTab: string) => {
    const updatedParams = {
      [INTERACTION_TAB]: {
        selectedTab: selectedSubTab,
        lastUsed: Date.now().toString()
      }
    };
    updateAndNavigate(updatedParams);
  }, []);

  const isSnoozed = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.pause?.data?.isPaused
  );

  const userRole = useSelector((state: RootState) => state.common.userData?.roles);
  const hasVisibilityRole = userRole?.some(role => PAUSE_CASE_LH_VISIBILITY_ROLES.includes(role));
  const hideTab = isSnoozed && !hasVisibilityRole;

  return (
    <div
      className={cx(styles.tabContainer, 'tabContentScroll', {
        tabContentScrollWithPausedCase: isSnoozed
      })}
    >
      <Tabs
        tabsClassName={styles.tabClass}
        orientation="vertical"
        variant="pill"
        contentClassName={styles.tabContent}
        containerClassName={styles.containerClass}
        selectedTabKey={queryParams?.selectedTab}
        onTabChange={event => handleTabChange(event as string)}
      >
        {COMMUNICATION_TABS.filter(
          tab =>
            !(
              hideTab &&
              (tab.key === COMMUNICATION_TAB_KEYS.NAVI_WHATSAPP ||
                tab.key === COMMUNICATION_TAB_KEYS.FIELD_VISIT)
            )
        ).map(tab => (
          <TabItem key={tab.key} label={tab.value}>
            {tab.component}
          </TabItem>
        ))}
      </Tabs>
    </div>
  );
}

export default CommunicationHistory;
